import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ILokalPlanFeatureProperties } from '../../../Interfaces/ILokalplan';
import {
  arrayStringToArray,
  dateNumberToDate,
  datePropertyToDateString,
} from '../../../util';
import { neutral } from '../../../style/colors';
import Anvendelse from './Anvendelse';
import HistoryIcon from '../../common/Icons/Light/History';
import { triggerHistoriskeLokalplaner } from '../../../store/actions';
import { connect } from 'react-redux';

const LokalplanInfo = (props: ILokalplanInfoPropTypes) => {
  const { properties, setTriggerHistorik } = props;
  useEffect(() => {
    setTriggerHistorik(false);
    return () => setTriggerHistorik(false);
  }, [setTriggerHistorik]);
  const {
    anvspec,
    datoikraft,
    anvgen,
    datoopdt,
    versionsnr,
    bygomfang: bygomfangString,
  } = properties;
  const bygomfang = bygomfangString ? JSON.parse(bygomfangString) : [];
  const anvspecListe = arrayStringToArray(anvspec);
  const keys = new Set();
  const uniqueanvspecListe = anvspecListe.filter(anvspec => {
    if (keys.has(anvspec)) {
      return false;
    }
    keys.add(anvspec);
    return true;
  });
  const gaeldendeFra = datoikraft
    ? dateNumberToDate(datoikraft).toLocaleDateString('da-DK')
    : '';
  const specifikeAnvendelser = uniqueanvspecListe.map(kode => {
    const bygomf = bygomfang.find(b => b.anvspec === parseInt(kode));
    return (
      <Anvendelse
        kode={parseInt(kode)}
        key={kode}
        bygomfang={bygomf}
        omfangBgColor={'#E4EAEF'}
      />
    );
  });
  const renderTidligereVersioner = () => {
    if (versionsnr === 1) return null;
    return (
      <span style={{ marginLeft: 60 }}>
        <HistoryIcon />
        <span
          style={{
            marginLeft: 5,
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => setTriggerHistorik(true)}
        >
          Se tidligere versioner
        </span>
      </span>
    );
  };
  return (
    <Wrapper>
      <h2>Lokalplan</h2>
      <h3 style={{ marginTop: 20 }}>I kraft fra</h3>
      <span style={{ marginLeft: 20 }}>{gaeldendeFra}</span>

      <h3>Opdateret</h3>
      <div
        style={{
          display: 'flex',
        }}
      >
        <span style={{ marginLeft: 20 }}>
          {datePropertyToDateString(datoopdt)}
        </span>
        {renderTidligereVersioner()}
      </div>
      <h3>Generel anvendelse</h3>
      <Anvendelser>
        <Anvendelse kode={anvgen} />
      </Anvendelser>
      <h3>Specifik anvendelse</h3>
      <Anvendelser>{specifikeAnvendelser}</Anvendelser>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 14px 32px;

  h3 {
    color: ${neutral[400]};
  }
`;

const Anvendelser = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const mapDispatchToProps = dispatch => {
  return {
    setTriggerHistorik: toggled => {
      dispatch(triggerHistoriskeLokalplaner(toggled));
    },
  };
};
interface ILokalplanInfoPropTypes {
  properties: ILokalPlanFeatureProperties;
  setTriggerHistorik: Function;
}
export default connect(
  null,
  mapDispatchToProps
)(LokalplanInfo);
